// @flow
import { Box, Typography } from '@mui/material'
import Divider from '@mui/material/Divider'
import { useTheme } from '@mui/material/styles'
import React from 'react'

type Props = {
    title?: string
};

const FormBoxTitle = (props: Props) => {
    const { title } = props
    const theme = useTheme()
    const color = theme.palette.formBox.titleColor
    const backgroundColor = theme.palette.formBox.titleBackground
    return (
        <Box className={'formBoxTitle'}>
            {title && (
                <Typography
                    variant={'subtitle2'}
                    component={'div'}
                    color={color}
                    sx={{ backgroundColor: backgroundColor }}
                    p={0.4}
                >
                    {title}
                </Typography>
            )}
            <Divider sx={{ borderColor: theme.palette.formBox.dividerColor, mb: 1 }}/>
        </Box>
    )
}

export default FormBoxTitle